import db from "astrid-firebase/src/db";
import useDocumentDataOnce from "astrid-firestore/src/hooks/useDocumentDataOnce";

export default function useOrganizationOnce(id) {
	const [data] = useDocumentDataOnce(id && db.collection("organizations").doc(id));

	return data;
}
